import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IServiceState } from "./service.types";
import {
  CLEAR_SERVICE_STATE,
  FETCH_SERVICE_CATEGORY_LIST_FAILED,
  FETCH_SERVICE_CATEGORY_LIST_PROGRESS,
  FETCH_SERVICE_CATEGORY_LIST_SUCCESS,
  FETCH_SERVICE_ITEM_LIST_FAILED,
  FETCH_SERVICE_ITEM_LIST_PROGRESS,
  FETCH_SERVICE_ITEM_LIST_SUCCESS,
} from "./serviceActions";
import { initialServiceState } from "./defaultState";

export const serviceReducer = (
  state: IServiceState = initialServiceState,
  action: any
): IServiceState => {
  switch (action.type) {
    // ==================== SERVICE CATEGORY REDUCERS ====================
    case FETCH_SERVICE_CATEGORY_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.serviceCategory.loading = LoadState.InProgress;
        draftState.serviceCategory.data = [];
        draftState.serviceCategory.totalRecords = 0;
        draftState.serviceCategory.error = null;
      });
    }

    case FETCH_SERVICE_CATEGORY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.serviceCategory.loading = LoadState.Loaded;
        draftState.serviceCategory.data = data;
        draftState.serviceCategory.totalRecords = totalRecords;
        draftState.serviceCategory.error = null;
      });
    }

    case FETCH_SERVICE_CATEGORY_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.serviceCategory.loading = LoadState.Failed;
        draftState.serviceCategory.error = "Failed to fetch service categories";
      });
    }

    // ==================== SERVICE ITEM REDUCERS ====================
    case FETCH_SERVICE_ITEM_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.serviceItem.loading = LoadState.InProgress;
        draftState.serviceItem.data = [];
        draftState.serviceItem.totalRecords = 0;
        draftState.serviceItem.error = null;
      });
    }

    case FETCH_SERVICE_ITEM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.serviceItem.loading = LoadState.Loaded;
        draftState.serviceItem.data = data;
        draftState.serviceItem.totalRecords = totalRecords;
        draftState.serviceItem.error = null;
      });
    }

    case FETCH_SERVICE_ITEM_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.serviceItem.loading = LoadState.Failed;
        draftState.serviceItem.error = "Failed to fetch service items";
      });
    }

    // ==================== CLEAR STATE ====================
    case CLEAR_SERVICE_STATE: {
      return initialServiceState;
    }

    default:
      return state;
  }
};
